import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ScenarioPanelComponent } from '../../scenario-panel/scenario-panel.component';
import { LampsSelectedService } from '../../../services/lamps-selected.service';
import { MapService } from '../../../services/map.service';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { ScenarioPlannerService } from '@app/shared/services/api/scenario-planner.service';
import { SidebarService } from '@app/shared/services/sidebar.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';
import { environment } from '@env/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-street-light-planner-recommended',
  templateUrl: './street-light-planner-recommended.component.html',
  styleUrls: [],
})
export class StreetLightPlannerRecommendedComponent implements OnInit, OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();
  @Input() scenario: any;
  @Output() maxStepChange = new EventEmitter<number>();
  @Output() stepChange = new EventEmitter<number>();
  @Output() backChange = new EventEmitter<Function>();
  @Output() nextChange = new EventEmitter<Function>();
  @Output() resetEvent = new EventEmitter();

  public step = 2;

  private maxStep = 3;
  maxPrice = 200000;
  private readonly minPrice = 10000;
  budgetLimit = 0;

  constructor(
    private lampsSelectedService: LampsSelectedService,
    private mapService: MapService,
    private overlayLoaderService: OverlayLoaderService,
    private scenarioPlannerService: ScenarioPlannerService,
    private sidebarService: SidebarService,
    private userMunicipalitiesService: UserMunicipalitiesService
  ) {}

  ngOnInit() {
    this.budgetLimit = parseFloat(environment.scenarioPlannerBudgetLimit);
    this.scenario.budget = this.minPrice;
    this.maxStepChange.emit(this.maxStep);
    this.stepChange.emit(this.step);
    this.backChange.emit(this.back);
    this.nextChange.emit(this.next);
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  back = () => {
    switch (this.step) {
      case 2:
        this.resetEvent.emit();
        break;
      case 3:
        this.step--;
        this.stepChange.emit(this.step);
        break;
    }
  };

  next = () => {
    if (this.step === this.maxStep) {
      this.loadScenarioPanel();
    } else {
      this.step++;
      this.stepChange.emit(this.step);
    }
  };

  public loadScenarioPanel() {
    this.mapService.selectMode(true);
    this.overlayLoaderService.isLoading = true;

    const budget = this.scenario.isBudget ? this.scenario.budget : this.budgetLimit;
    const userCurrentIsoCode = this.userMunicipalitiesService.currentMunicipality.key;

    this.scenarioPlannerService
      .getRecommendations(userCurrentIsoCode, this.scenario.recommendationType, budget)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((lamps: any) => {
        this.overlayLoaderService.isLoading = false;

        lamps.forEach((lamp: any) => {
          lamp.isRecommended = true;
        });

        this.lampsSelectedService.addLamps(lamps);

        this.sidebarService.showComponent(ScenarioPanelComponent, {
          budget,
          recommendationType: this.scenario.recommendationType,
          recommendationTypeId: this.scenario.recommendationTypeId,
          isSameManufacturer: false,
        });
      });
  }

  public onReusedChange(value: boolean) {
    this.scenario.isSameManufacturer = value;
  }

  public onTypeChange(value: any) {
    this.scenario.recommendationTypeId = value.id;
    this.scenario.recommendationType = value.name;
  }
}
